import {ChangeDetectionStrategy, Component, computed, Injectable, input, Signal} from '@angular/core';

import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {AksjeeierEnkelModell, AksjeeierId, AksjeeierModell, Aksjeeiertype} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {AksjeeierDatatjeneste} from "felles-ng2/tjenester/datalager/AksjeeierDatatjeneste";
import {distinctUntilChanged, Observable, switchMap, tap} from "rxjs";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {FormaterProsentPipe} from "felles-ng2/pipes/FormaterProsentPipe";
import {StandardTekstPipe} from "felles-ng2/pipes/StandardTekstPipe";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";
import {TittelVerdiKomponent, VerdiKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi";
import {TittelVerdiSamlingKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi-samling";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";
import {AksjeeiereRedigerBeholdningDialogKomponent} from "web-ng2/moduler/aksjeeierbok/modale/aksjeeiere-rediger-beholdning-dialog/aksjeeiere-rediger-beholdning-dialog";
import {MatDialog} from "@angular/material/dialog";
import {toObservable, toSignal} from "@angular/core/rxjs-interop";
import {erTomEllerNil} from "felles-ng2/støttefunksjoner/strenger";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {tomAksjeeierModell} from "felles-ng2/modell/tommeModeller";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {TranslateModule} from "@ngx-translate/core";
import {map} from "rxjs/operators";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";

const debug = initDebugger('AksjeeierKomponent');

@Component({
    selector: 'aksjeeierbok-aksjeeier',
    templateUrl: './aksjeeier.html',
    styleUrls: ['./aksjeeier.scss'],
    imports: [
        FormaterPlainDatePipe,
        FormaterProsentPipe,
        StandardTekstPipe,
        TipsKomponent,
        TittelVerdiSamlingKomponent,
        TittelVerdiKomponent,
        VerdiKomponent,
        InlineMeldingKomponent,
        TranslateModule,
        HtmlFormatertKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AksjeeierKomponent {

    aksjeeier = input.required<AksjeeierEnkelModell>();

    aksjeeierDetaljer!: Signal<AksjeeierModell>;
    erPerson = computed(() => this.aksjeeier().type == Aksjeeiertype.person);
    manglendeInformasjon = computed(() => this.beregnManglendeInformasjon(this.aksjeeier()));

    constructor(private avhengigheter: AksjeeierKomponentAvhengigheter, private oversettelser: Oversettelser, private dialog: MatDialog) {
        this.aksjeeierDetaljer = toSignal(toObservable(this.aksjeeier)
            .pipe(
              map(aksjeeier => aksjeeier.id),
              //kun last detaljer dersom id endres - viktig da avhengigheter.hent() vil føre til at ny verdi blir lever til AksjeeierKomponent.aksjeeier,
              //hvorpå vi får en rekursjon dersom vi ikke struper her
              distinctUntilChanged(),
              switchMap(id => this.avhengigheter.hent(id))),
          {initialValue: tomAksjeeierModell()});
    }

    registrerBeholdning() {
        AksjeeiereRedigerBeholdningDialogKomponent.vis(this.aksjeeier().aksjeeierbokId, this.dialog);
    }

    //hjelpemetoder

    private beregnManglendeInformasjon(aksjeeier: AksjeeierEnkelModell): string[] {
        const manglendeInformasjon = [];
        if (erTomEllerNil(aksjeeier.adresse)) manglendeInformasjon.push(this.oversettelser.oversett(i18n('Adresse')));
        if (erTomEllerNil(aksjeeier.epost)) manglendeInformasjon.push(this.oversettelser.oversett(i18n('E-post')));
        if (aksjeeier.type == Aksjeeiertype.person && erNil(aksjeeier.foedselsdato)) manglendeInformasjon.push(this.oversettelser.oversett(i18n('Fødselsdato')));
        if (aksjeeier.type == Aksjeeiertype.organisasjon && erTomEllerNil(aksjeeier.organisasjonsnummer)) manglendeInformasjon.push(this.oversettelser.oversett(i18n('Organisasjonsnummer')));
        return manglendeInformasjon;
    }
}


@Injectable()
export class AksjeeierKomponentAvhengigheter {

    constructor(private aksjeeierDatatjeneste: AksjeeierDatatjeneste) {
    }

    hent(aksjeeierId: AksjeeierId): Observable<AksjeeierModell> {
        return this.aksjeeierDatatjeneste.hent(aksjeeierId);
    }
}
